import React from 'react'
import Slider from "react-slick";
const News = () => {
    var settings = {
        autoplay: true,
        infinite: true,
        autoplaySpeed: 2000,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 0,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 1,
                slidesToScroll:1,
              }
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2,
                slidesToScroll:2,
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                initialSlide: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
      };
  return (
     <>
     <Slider {...settings}>
     <div>
                 <div className="news-blk">
                     <div className="date">
                         <h3>02<span>Feb</span></h3>
                     </div>
                     <div className="content">
                         <h3>News Title</h3>
                         <p>Stay connected for more updates!</p>
                     </div>
                 </div>
           </div>
           <div>
                 <div className="news-blk">
                     <div className="date">
                         <h3>02<span>Feb</span></h3>
                     </div>
                     <div className="content">
                         <h3>News Title</h3>
                         <p>Stay connected for more updates!</p>
                     </div>
                 </div>
          </div>
          <div>
                 <div className="news-blk">
                     <div className="date">
                         <h3>02<span>Feb</span></h3>
                     </div>
                     <div className="content">
                         <h3>News Title</h3>
                         <p>Stay connected for more updates!</p>
                     </div>
                 </div>
                 </div>
         </Slider>
     </>
  )
}

export default News